'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (entity, text, options) {
  var at = text.substring(entity.indices[0], entity.indices[0] + 1);
  var user = (0, _htmlEscape2.default)(entity.screenName);
  var slashListname = (0, _htmlEscape2.default)(entity.listSlug);
  var isList = entity.listSlug && !options.suppressLists;
  var attrs = (0, _clone2.default)(options.htmlAttrs || {});
  attrs['class'] = isList ? options.listClass : options.usernameClass;
  attrs.href = isList ? options.listUrlBase + user + slashListname : options.usernameUrlBase + user;
  if (!isList && !options.suppressDataScreenName) {
    attrs['data-screen-name'] = user;
  }
  if (options.targetBlank) {
    attrs.target = '_blank';
  }

  return (0, _linkToTextWithSymbol2.default)(entity, at, isList ? user + slashListname : user, attrs, options);
};

var _clone = require('./lib/clone');

var _clone2 = _interopRequireDefault(_clone);

var _htmlEscape = require('./htmlEscape');

var _htmlEscape2 = _interopRequireDefault(_htmlEscape);

var _linkToTextWithSymbol = require('./linkToTextWithSymbol');

var _linkToTextWithSymbol2 = _interopRequireDefault(_linkToTextWithSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];